import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FiscalInfo } from "@/components/FiscalInfo";

const LOGO_URL = "/veritel-logo.jpeg";

export const TermsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-300 px-6 py-20">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" onClick={() => navigate("/")} className="text-zinc-500 hover:text-white mb-8"><ArrowLeft className="w-4 h-4 mr-2" />Volver</Button>
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Veritel" className="w-8 h-8" />
          <h1 className="text-3xl font-bold text-white">Terminos y Condiciones</h1>
        </div>
        <div className="space-y-6 text-sm leading-relaxed">
          <p><strong className="text-white">Ultima actualizacion:</strong> Marzo 2026</p>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Aceptacion de los Terminos</h2>
            <p>Al acceder y utilizar Veritel (veritel.com.ar), aceptas estos terminos y condiciones en su totalidad. Si no estas de acuerdo, no utilices el servicio.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Descripcion del Servicio</h2>
            <p>Veritel es una plataforma de verificacion de contactos (telefonos, emails y WhatsApp) que permite el procesamiento individual y masivo de datos de contacto para validar su estado y calidad.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Uso del Servicio</h2>
            <p>El usuario se compromete a utilizar Veritel unicamente con fines licitos y de acuerdo con la legislacion vigente en la Republica Argentina. Esta prohibido el uso del servicio para spam, acoso o cualquier actividad ilegal.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Sistema de Creditos</h2>
            <p>El acceso a las funcionalidades de verificacion requiere creditos asignados por el administrador de la empresa. Los creditos se consumen al realizar verificaciones y no son reembolsables.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Cuentas de Usuario</h2>
            <p>Cada usuario accede mediante autenticacion de Google. El acceso esta restringido a los emails autorizados por la empresa correspondiente.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Propiedad Intelectual</h2>
            <p>Todo el contenido, codigo y diseno de Veritel es propiedad de sus creadores. Los datos cargados por los usuarios son propiedad de cada usuario/empresa.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Limitacion de Responsabilidad</h2>
            <p>Veritel proporciona los resultados de verificacion &quot;tal cual&quot;. No garantizamos la exactitud al 100% de los resultados y no somos responsables por decisiones tomadas en base a los mismos.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. Modificaciones</h2>
            <p>Nos reservamos el derecho de modificar estos terminos en cualquier momento. Los cambios seran notificados a traves de la plataforma.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">9. Contacto</h2>
            <p>Para consultas sobre estos terminos, podes contactarnos a traves del formulario en veritel.com.ar o por los medios indicados al pie de esta pagina.</p>
          </section>
        </div>
        <FiscalInfo />
      </div>
    </div>
  );
};

export const PrivacyPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-300 px-6 py-20">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" onClick={() => navigate("/")} className="text-zinc-500 hover:text-white mb-8"><ArrowLeft className="w-4 h-4 mr-2" />Volver</Button>
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Veritel" className="w-8 h-8" />
          <h1 className="text-3xl font-bold text-white">Politica de Privacidad</h1>
        </div>
        <div className="space-y-6 text-sm leading-relaxed">
          <p><strong className="text-white">Ultima actualizacion:</strong> Marzo 2026</p>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Datos que Recopilamos</h2>
            <p>Recopilamos los siguientes datos: nombre, email y foto de perfil (proporcionados por Google Auth), archivos de contactos subidos para verificacion, y registros de uso del servicio.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Uso de los Datos</h2>
            <p>Los datos recopilados se utilizan exclusivamente para: autenticacion y gestion de cuentas, procesamiento de verificaciones solicitadas, generacion de estadisticas de uso, y mejora del servicio.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Almacenamiento</h2>
            <p>Los datos se almacenan en servidores seguros. Los archivos subidos se procesan y los resultados se almacenan asociados a la empresa del usuario. No compartimos datos entre empresas.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Segregacion de Datos</h2>
            <p>Veritel implementa un sistema multi-empresa que garantiza que cada empresa solo puede acceder a sus propios datos. Los datos de una empresa nunca son visibles para otra.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Compartir Datos</h2>
            <p>No vendemos, alquilamos ni compartimos datos personales con terceros, excepto cuando sea requerido por ley o autoridad competente.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Derechos del Usuario</h2>
            <p>Conforme a la Ley 25.326 de Proteccion de Datos Personales de Argentina, tenes derecho a acceder, rectificar y suprimir tus datos personales contactandonos directamente.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">7. Cookies y Sesiones</h2>
            <p>Utilizamos cookies de sesion para mantener tu autenticacion activa. No utilizamos cookies de seguimiento de terceros con fines publicitarios.</p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">8. Contacto</h2>
            <p>Para ejercer tus derechos o consultas sobre privacidad, podes contactarnos a traves del formulario en veritel.com.ar o por los medios indicados al pie de esta pagina.</p>
          </section>
        </div>
        <FiscalInfo />
      </div>
    </div>
  );
};

export const DataDeletionPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#09090B] text-zinc-300 px-6 py-20">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" onClick={() => navigate("/")} className="text-zinc-500 hover:text-white mb-8" data-testid="back-btn">
          <ArrowLeft className="w-4 h-4 mr-2" />Volver
        </Button>
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Veritel" className="w-8 h-8" />
          <h1 className="text-3xl font-bold text-white">Eliminacion de Datos</h1>
        </div>
        <div className="space-y-6 text-sm leading-relaxed">
          <p><strong className="text-white">Ultima actualizacion:</strong> Junio 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">1. Tu derecho a eliminar tus datos</h2>
            <p>
              En Veritel respetamos tu derecho a la privacidad. Conforme a la Ley 25.326 de Proteccion de Datos
              Personales de la Republica Argentina y a las politicas de Meta/Facebook, podes solicitar en cualquier
              momento la eliminacion total de tus datos personales y de los datos asociados a tu cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">2. Que datos eliminamos</h2>
            <ul className="list-disc pl-6 space-y-1.5">
              <li>Datos de tu perfil (nombre, email, foto) obtenidos via Google/Facebook Login.</li>
              <li>Archivos de contactos que hayas subido a la plataforma.</li>
              <li>Resultados de verificaciones (telefonos, emails, WhatsApp) procesados con tu cuenta.</li>
              <li>Historial de campanas, grupos de WhatsApp asociados y notificaciones.</li>
              <li>Registros de uso, creditos consumidos y configuraciones personales.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">3. Como solicitar la eliminacion</h2>
            <p>Tenes dos opciones:</p>
            <div className="mt-3 space-y-3">
              <div className="p-4 rounded-lg border border-violet-500/20 bg-violet-500/5">
                <p className="font-semibold text-violet-300 mb-1">Opcion A: Por email (recomendado)</p>
                <p>
                  Enviá un correo a{" "}
                  <a href="mailto:veritelwhat@gmail.com?subject=Solicitud%20de%20eliminacion%20de%20datos&body=Solicito%20la%20eliminacion%20de%20todos%20mis%20datos%20personales%20asociados%20a%20mi%20cuenta%20de%20Veritel.%0A%0AEmail%20de%20la%20cuenta%3A%20" className="text-violet-400 hover:underline">veritelwhat@gmail.com</a>{" "}
                  con el asunto <em className="text-zinc-200">&quot;Solicitud de eliminacion de datos&quot;</em>, indicando el email de tu cuenta.
                </p>
              </div>
              <div className="p-4 rounded-lg border border-violet-500/20 bg-violet-500/5">
                <p className="font-semibold text-violet-300 mb-1">Opcion B: Por WhatsApp</p>
                <p>
                  Escribinos al{" "}
                  <a href="https://wa.me/5491124510886?text=Hola%2C%20solicito%20la%20eliminacion%20de%20mis%20datos%20de%20Veritel." target="_blank" rel="noopener noreferrer" className="text-violet-400 hover:underline">+54 9 11 2451-0886</a>{" "}
                  indicando el email registrado en tu cuenta.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">4. Plazo de procesamiento</h2>
            <p>
              Procesaremos tu solicitud dentro de un plazo maximo de <strong className="text-white">30 dias habiles</strong>.
              Una vez completada la eliminacion, recibiras una confirmacion por email. Algunos datos podrian
              conservarse por un periodo adicional si la ley lo requiere (facturacion, obligaciones fiscales).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">5. Eliminacion automatica al revocar acceso</h2>
            <p>
              Si iniciaste sesion con Google o Facebook y revocas el acceso desde la configuracion de tu cuenta de
              esos servicios, recibiremos una notificacion y procederemos a eliminar los datos asociados a tu perfil
              dentro de los plazos indicados.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">6. Contacto</h2>
            <p>
              Para cualquier consulta adicional sobre el manejo de tus datos personales, contactanos por los medios
              indicados al pie de esta pagina.
            </p>
          </section>
        </div>
        <FiscalInfo />
      </div>
    </div>
  );
};
